import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import React from 'react';
import {
  NaturezaTributacao,
  RegimeApuracaoTributaria,
  RegimeTributario,
  RegimeTributarioEspecial,
  SituacaoTributariaCofins,
  SituacaoTributariaPis,
  TipoTributacao,
} from '../enums';

const TIPO_INDICADOR_OPERACAO = {
  NAO_APLICA: '0 - Não se aplica',
  INTERNA: '1 - Interna',
  INTERESTADUAL: '2 - Interestadual',
  EXTERIOR: '3 - Exterior',
};

const TributacaoVisualizar = ({ tributacao }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextLabel label="Produtor rural" value={tributacao?.produtorRural ? 'Sim' : 'Não'} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Optante pelo SIMPLES" value={tributacao?.optanteSimples ? 'Sim' : 'Não'} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="É incentivador cultural" value={tributacao?.incentivadorCultural ? 'Sim' : 'Não'} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Natureza da tributação" value={NaturezaTributacao[tributacao?.naturezaTributacao]} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Tipo da tributação" value={TipoTributacao[tributacao?.tipoTributacao]} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel label="Regime tributário" value={RegimeTributario[tributacao?.regimeTributario]} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel
          label="Regime tributário especial"
          value={RegimeTributarioEspecial[tributacao?.regimeTributarioEspecial]}
        />
      </Grid>

      {tributacao?.situacaoTributariaPis ? (
        <>
          <Grid item xs={6}>
            <TextLabel
              label="Situação tributária PIS"
              value={SituacaoTributariaPis[tributacao?.situacaoTributariaPis]}
            />
          </Grid>

          <Grid item xs={6}>
            <TextLabel label="Alíquota do PIS (%)" value={tributacao?.aliquotaPis} />
          </Grid>
        </>
      ) : null}

      {tributacao?.situacaoTributariaCofins ? (
        <>
          <Grid item xs={6}>
            <TextLabel
              label="Situação tributária COFINS"
              value={SituacaoTributariaCofins[tributacao?.situacaoTributariaCofins]}
            />
          </Grid>

          <Grid item xs={6}>
            <TextLabel label="Alíquota do COFINS (%)" value={tributacao?.aliquotaCofins} />
          </Grid>
        </>
      ) : null}

      <Grid item xs={6}>
        <TextLabel
          label="Regime de apuração tributária"
          value={RegimeApuracaoTributaria[tributacao?.regimeApuracaoTributaria]}
        />
      </Grid>
      <Grid item xs={12}>
        <TextLabel
          label="Nomenclatura brasileira de serviços (NBS)"
          value={tributacao?.nbs?.id ? `${tributacao?.nbs?.codigo} - ${tributacao?.nbs?.descricao}` : ' - '}
        />
      </Grid>

      {tributacao?.ibsCbs && (
        <>
          <Grid item xs={6}>
            <TextLabel
              label="Código de situação tributária (CST)"
              value={
                tributacao?.cstSituacaoTributaria?.id
                  ? `${tributacao?.cstSituacaoTributaria?.codigo} - ${tributacao?.cstSituacaoTributaria?.descricao}`
                  : ' - '
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextLabel
              label="Código de classificação tributária"
              value={
                tributacao?.cstClassificacaoTributaria?.id
                  ? `${tributacao?.cstClassificacaoTributaria?.codigo} - ${tributacao?.cstClassificacaoTributaria?.descricao}`
                  : ' - '
              }
            />
          </Grid>

          <Grid item xs={6}>
            <TextLabel label="Contribuinte IBS" value={tributacao?.contribuinteIbs ? 'Sim' : 'Não'} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Contribuinte CBS" value={tributacao?.contribuinteCbs ? 'Sim' : 'Não'} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel label="Contribuinte IS" value={tributacao?.contribuinteIs ? 'Sim' : 'Não'} />
          </Grid>
          <Grid item xs={6}>
            <TextLabel
              id="tipoIndicadorOperacao"
              label="Tipo indicador operação"
              value={TIPO_INDICADOR_OPERACAO[tributacao?.tipoIndicadorOperacao] || tributacao?.tipoIndicadorOperacao}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default TributacaoVisualizar;
